<script>
  import { Input, Popover } from '@sveltestrap/sveltestrap';

  import LogoChoice from '@client/components/brand-wizard/logo-choice.svelte';

  import { images, loadingAssets } from '@client/stores/assets';

  import { generateUUID } from '@common/utils/strings';

  export let value = '';

  export let onChange = (newValue) => {};

  const id = `background-image-${generateUUID()}`;

  let url = '';

  const handleInput = (event) => {
    const newUrl = event.target.value;

    onChange(newUrl ? `url("${newUrl}")` : '');
  };

  // Unwraps the url(...) string value for display in the input.
  $: {
    const match = /^url\((['"]?)([\s\S]*?)\1\)$/.exec(value);
    url = match ? match[2] : value || '';
  }

  // Wrap the url value in CSS property syntax.
  $: {
    onChange(url ? `url('${url}')` : '');
  }
</script>

<Input {...$$restProps} {id} value={url} on:input={handleInput} />

{#if !$loadingAssets}
  <Popover placement="left" target={id} hideOnOutsideClick style="min-width: 30rem">
    <LogoChoice bind:value={url} images={$images} />
  </Popover>
{/if}
